var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoColWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 24,
    viewBox: "0 0 176 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_col"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.7779 6.21778L51.7198 15.6899C51.7198 17.8401 51.6035 19.9902 49.9183 21.6173C48.5236 23.012 46.3154 23.4769 44.3396 23.4187C42.3638 23.4187 40.1556 22.8957 38.7609 21.5011C37.0757 19.874 37.0176 17.7238 37.0176 15.5737L37.0757 6.15967L41.434 6.21778L41.3759 15.0507C41.3759 17.2589 41.4922 19.6415 44.2815 19.6415C47.0708 19.6415 47.2452 17.2589 47.3033 15.1088L47.3614 6.27589L51.7779 6.21778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M56.4261 6.27588H60.7263L64.0387 15.2831L67.6997 6.33399L72.0581 6.3921L74.4406 23.1863L70.0823 23.1282L68.92 13.4817L64.7941 23.1282L63.0508 23.0701L59.2735 13.4236H59.2154L57.7627 23.0701L53.4043 23.012L56.4261 6.27588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M89.2001 17.6077C89.142 21.5012 85.9459 23.6513 82.2849 23.6513C78.6239 23.6513 75.4277 21.443 75.4277 17.5496C75.4858 13.6561 78.682 11.4479 82.343 11.506C86.004 11.4479 89.2001 13.7142 89.2001 17.6077ZM79.6699 17.4915C79.6699 18.9443 80.5996 20.0484 82.2268 20.0484C83.8539 20.0484 84.8418 18.9443 84.8418 17.4915C84.8418 16.0968 83.912 14.8765 82.2849 14.8765C80.6578 14.9346 79.728 16.0968 79.6699 17.4915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M99.544 22.0823C98.7885 23.1864 97.3938 23.7094 96.0573 23.7094C92.6868 23.7094 90.3043 20.862 90.3624 17.5496C90.3624 14.2954 92.7449 11.5061 96.1154 11.5061C97.452 11.5061 98.7885 12.0291 99.6602 13.0169L99.7183 4.82324L103.786 4.88135L103.67 23.3608L99.6021 23.3027L99.544 22.0823ZM94.4883 17.6077C94.4883 19.0605 95.4181 20.1646 97.0452 20.1646C98.6723 20.1646 99.6602 19.0605 99.6602 17.6077C99.6602 16.2131 98.7304 14.9927 97.1033 14.9927C95.4762 15.0508 94.5464 16.2131 94.4883 17.6077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M117.907 18.4793L109.365 18.4212C109.365 20.0483 110.236 20.9781 111.863 20.9781C112.735 20.9781 113.374 20.6875 113.781 19.9321L117.675 19.9902C117.035 22.6633 114.42 23.8837 111.863 23.8837C108.086 23.8837 105.297 21.6754 105.297 17.782C105.297 13.9466 107.97 11.6803 111.689 11.7384C115.641 11.7965 117.907 14.2372 117.907 18.1306V18.4793ZM114.13 16.0967C113.955 14.9926 112.968 14.2953 111.863 14.2953C110.701 14.2953 109.713 14.8764 109.423 16.0967H114.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M119.847 5.03474L119.709 23.5142L123.777 23.5445L123.915 5.06507L119.847 5.03474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M138.188 18.5955L129.646 18.5374C129.646 20.1645 130.518 21.0943 132.145 21.0943C133.016 21.0943 133.656 20.8038 134.062 20.0483L137.956 20.1064C137.317 22.7795 134.702 23.9999 132.145 23.9999C128.367 23.9999 125.578 21.7917 125.578 17.8982C125.578 14.0628 128.251 11.7965 131.97 11.8546C135.922 11.9127 138.188 14.3534 138.188 18.2469V18.5955ZM134.469 16.2711C134.295 15.167 133.307 14.4696 132.203 14.4696C131.041 14.4696 130.053 15.0507 129.762 16.2711H134.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M144.116 14.121C144.929 12.7263 146.266 12.0871 147.893 12.1452H148.648L148.59 16.0387C148.009 15.7481 147.486 15.6319 146.905 15.6319C144.639 15.6319 144.116 17.0847 144.058 19.0605L143.999 23.6513L139.932 23.5932L139.99 12.1452L144.058 12.2033L144.116 14.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M5.28814 12.7263V0.581055H0V12.7263C0 18.5956 4.76513 23.3607 10.5763 23.3607V18.0145C7.6707 18.0145 5.28814 15.69 5.28814 12.7263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M20.4551 23.3608V6.15981L10.5762 0V6.50847L15.0507 9.1816V23.3608H20.4551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M31.4971 23.3608V6.15981L21.7344 0V6.50847L26.2089 9.1816V23.3608H31.4971Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColWhite);
export default __webpack_public_path__ + "static/media/logo_col_white.d30a2c42512fc269d28eea8cb2d3bd86.svg";
export { ForwardRef as ReactComponent };